import type { ShipmentStateEnum } from 'graphql-models';
import { t } from 'walden-fast/utils/intl';

export const SHIPMENT_STATE_TRANSLATIONS: Record<ShipmentStateEnum, string> = {
  DELIVERED: t('app.shipmentState.delivered'),
  NOT_DELIVERED: t('app.shipmentState.notDelivered'),
  ORDER_PACKED: t('app.shipmentState.orderPacked'),
  ORDER_RECEIVED: t('app.shipmentState.orderReceived'),
  SHIPPING_IN_PROGRESS: t('app.shipmentState.shippingInProgress'),
  TRANSPORT_ORDER_RECEIVED: t('app.shipmentState.transportOrderReceived'),
};
